const translation = {
  createApp: 'CRIAR APLICATIVO',
  types: {
    all: 'Todos',
    chatbot: 'Chatbot',
    agent: 'Agente',
    workflow: 'Fluxo de trabalho',
    completion: 'Conclusão',
  },
  duplicate: 'Duplicar',
  duplicateTitle: 'Duplicar Aplicativo',
  export: 'Exportar DSL',
  exportFailed: 'Falha ao exportar DSL.',
  importDSL: 'Importar arquivo DSL',
  createFromConfigFile: 'Criar a partir do arquivo DSL',
  deleteAppConfirmTitle: 'Excluir este aplicativo?',
  deleteAppConfirmContent:
    'A exclusão do aplicativo é irreversível. Os usuários não poderão mais acessar seu aplicativo e todas as configurações de prompt e logs serão permanentemente excluídas.',
  appDeleted: 'Aplicativo excluído',
  appDeleteFailed: 'Falha ao excluir aplicativo',
  join: 'Participe da comunidade',
  communityIntro:
    'Discuta com membros da equipe, colaboradores e desenvolvedores em diferentes canais.',
  roadmap: 'Veja nosso roteiro',
  newApp: {
    startFromBlank: 'Criar do zero',
    startFromTemplate: 'Criar do modelo',
    captionAppType: 'Que tipo de aplicativo você deseja criar?',
    chatbotDescription: 'Construa um aplicativo baseado em chat. Este aplicativo usa um formato de pergunta e resposta, permitindo várias rodadas de conversa contínua.',
    completionDescription: 'Construa um aplicativo que gera texto de alta qualidade com base em prompts, como geração de artigos, resumos, traduções e muito mais.',
    completionWarning: 'Este tipo de aplicativo não será mais suportado.',
    agentDescription: 'Construa um Agente inteligente que pode escolher ferramentas para completar as tarefas autonomamente',
    workflowDescription: 'Construa um aplicativo que gera texto de alta qualidade com base em fluxo de trabalho com alto grau de personalização. É adequado para usuários experientes.',
    workflowWarning: 'Atualmente em beta',
    chatbotType: 'Método de orquestração do Chatbot',
    basic: 'Básico',
    basicTip: 'Para iniciantes, pode mudar para o Chatflow mais tarde',
    basicFor: 'PARA INICIANTES',
    basicDescription: 'A Orquestração Básica permite orquestrar um aplicativo Chatbot usando configurações simples, sem a capacidade de modificar prompts integrados. É adequado para iniciantes.',
    advanced: 'Chatflow',
    advancedFor: 'Para usuários avançados',
    advancedDescription: 'A Orquestração de Fluxo de Trabalho orquestra Chatbots na forma de fluxos de trabalho, oferecendo um alto grau de personalização, incluindo a capacidade de editar prompts integrados. É adequado para usuários experientes.',
    captionName: 'Ícone e nome do aplicativo',
    appNamePlaceholder: 'Dê um nome para o seu aplicativo',
    captionDescription: 'Descrição',
    appDescriptionPlaceholder: 'Digite a descrição do aplicativo',
    useTemplate: 'Usar este modelo',
    previewDemo: 'Visualizar demonstração',
    chatApp: 'Assistente',
    chatAppIntro:
      'Eu quero construir um aplicativo baseado em chat. Este aplicativo usa um formato de pergunta e resposta, permitindo várias rodadas de conversa contínua.',
    agentAssistant: 'Novo Assistente de Agente',
    completeApp: 'Gerador de Texto',
    completeAppIntro:
      'Eu quero criar um aplicativo que gera texto de alta qualidade com base em prompts, como geração de artigos, resumos, traduções e muito mais.',
    showTemplates: 'Quero escolher a partir de um modelo',
    hideTemplates: 'Voltar para a seleção de modo',
    Create: 'Criar',
    Cancel: 'Cancelar',
    nameNotEmpty: 'O nome não pode estar vazio',
    appTemplateNotSelected: 'Por favor, selecione um modelo',
    appTypeRequired: 'Por favor, selecione um tipo de aplicativo',
    appCreated: 'Aplicativo criado',
    appCreateFailed: 'Falha ao criar aplicativo',
  },
  editApp: 'Editar Informações',
  editAppTitle: 'Editar Informações do Aplicativo',
  editDone: 'Informações do aplicativo atualizadas',
  editFailed: 'Falha ao atualizar informações do aplicativo',
  emoji: {
    ok: 'OK',
    cancel: 'Cancelar',
  },
  switch: 'Mudar para Orquestração de Fluxo de Trabalho',
  switchTipStart: 'Será criada uma nova cópia do aplicativo para você e a nova cópia mudará para Orquestração de Fluxo de Trabalho. A nova cópia não permitirá a ',
  switchTip: 'volta',
  switchTipEnd: ' para Orquestração Básica.',
  switchLabel: 'A cópia do aplicativo a ser criada',
  removeOriginal: 'Excluir o aplicativo original',
  switchStart: 'Iniciar mudança',
  typeSelector: {
    all: 'Todos os Tipos',
    chatbot: 'Chatbot',
    agent: 'Agente',
    workflow: 'Fluxo de trabalho',
    completion: 'Conclusão',
  },
}

export default translation
